const fields = {
  amount: {
    name: 'purchase_amount'
  },
  dependants: {
    label: 'eligibility.pre_assessment.affordability_form.dependants',
    name: 'dependants',
    type: 'INTEGER'
  },
  minYearlyGrossIncome: {
    label: 'eligibility.pre_assessment.affordability_form.min_yearly_gross_income',
    name: 'min_yearly_gross_income',
    type: 'IMPLICIT_DECIMAL'
  },
  maxHousingCostPercentage: {
    label: 'eligibility.pre_assessment.affordability_form.max_housing_cost_percentage',
    name: 'max_housing_cost_percentage',
    type: 'IMPLICIT_DECIMAL'
  }
}

export default fields
